import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// core components

import Parallax from 'components/Parallax/Parallax.jsx';
import Footer from 'components/Footer/Footer.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Button from 'components/CustomButtons/Button.jsx';
// sections for this page
import SectionComponents from 'views/YogaPage/Sections/SectionComponents.jsx';
import SectionCards from 'views/YogaPage/Sections/SectionCards.jsx';
import SectionContent from 'views/YogaPage/Sections/SectionContent.jsx';
import SectionSections from 'views/YogaPage/Sections/SectionSections.jsx';
import SectionExamples from 'views/YogaPage/Sections/SectionExamples.jsx';
import SectionFreeDemo from 'views/YogaPage/Sections/SectionFreeDemo.jsx';
import SectionOverview from 'views/YogaPage/Sections/SectionOverview.jsx';
import SectionPricing from 'views/YogaPage/Sections/SectionPricing.jsx';
import AboutUsPage from './Sections/AboutUsPage/AboutUsPage';
import presentationStyle from 'assets/jss/material-kit-pro-react/views/presentationStyle.jsx';

import YogaHeader from './YogaHeader';
import Gallery from './Gallery';
import EventCarousel from './EventCarousel';

class YogaPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes } = this.props;
    return (
      <div>
        <YogaHeader classes={classes} />
        <Parallax
          image={require('assets/img/ira_about_us.jpg')}
          className={classes.parallax}
        >
          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1>Just breathe</h1>
                  <h3 className={classes.title}>
                    It's not about being good at something. It's about being
                    good to yourself.
                  </h3>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main)}>
          <AboutUsPage />
          <SectionSections />
          <SectionExamples />
          <EventCarousel {...classes} />
        </div>
      </div>
    );
  }
}

export default withStyles(presentationStyle)(YogaPage);



// WEBPACK FOOTER //
// ./src/views/YogaPage/YogaPage.jsx